import type { AddressStruct, User } from '../../../../../../../types/common';

export type UnknownRecord = Record<string, unknown>;
export type DateOfBirthContainer = { date?: string | null };
export type UserAddressContainer = { raw: string; struct: AddressStruct | null };
export type UserProfile = {
    firstName?: string;
    lastName?: string;
    middleName?: string;
    dateOfBirth?: DateOfBirthContainer | null;
    phoneNumber?: string;
    email?: string;
    emailStatus?: boolean | null;
    address?: UserAddressContainer | null;
    marketing?: {
        discounts_and_promotions: boolean;
        createdAt?: string;
        updatedAt?: string;
    } | null;
    addresses?: unknown; // TODO: когда появится массив адресов..
};

export const isRecord = (v: unknown): v is UnknownRecord => typeof v === 'object' && v !== null && !Array.isArray(v);
export const getString = (v: unknown): string => (typeof v === 'string' ? v : '');
export const getTrimmedString = (v: unknown): string => getString(v).trim();
export const getBool = (v: unknown): boolean | undefined => (typeof v === 'boolean' ? v : undefined);
export const getIsoString = (v: unknown): string | undefined => {
    const s = typeof v === 'string' ? v.trim() : '';
    if (!s) return undefined;
    const t = Date.parse(s);
    return Number.isFinite(t) ? s : undefined;
};
export const getNumber = (v: unknown): number | undefined => (typeof v === 'number' && Number.isFinite(v) ? v : undefined);
export const getIdLike = (v: unknown): string | number | null => {
    if (typeof v === 'string') return v;
    if (typeof v === 'number' && Number.isFinite(v)) return v;
    return null;
};

export const coerceUserProfile = (v: unknown): Partial<User> => {
    if (!isRecord(v)) return {};
    const dateOfBirth = (() => {
        const dob = v.dateOfBirth;
        if (!isRecord(dob)) return undefined;
        const dateRaw = dob.date;
        const date = typeof dateRaw === 'string' ? dateRaw : '';
        if (!date.trim()) return undefined;
        return { date: date.trim() };
    })();
    const address = (() => {
        const a = v.address;
        if (!isRecord(a)) return null;
        const raw = getTrimmedString(a.raw);
        const struct = a.struct;
        if (!raw || !isRecord(struct)) return null;
        return { raw, struct: struct as unknown as AddressStruct };
    })();
    const marketing = (() => {
        const m = v.marketing;
        if (m === null) return null;
        if (!isRecord(m)) return undefined;
        const dap = getBool(m.discounts_and_promotions);
        if (dap === undefined) return undefined;
        return {
            discounts_and_promotions: dap,
            createdAt: getIsoString(m.createdAt),
            updatedAt: getIsoString(m.updatedAt),
        };
    })();
    return {
        firstName: getTrimmedString(v.firstName),
        lastName: getTrimmedString(v.lastName),
        middleName: getTrimmedString(v.middleName),
        phoneNumber: getTrimmedString(v.phoneNumber),
        email: getTrimmedString(v.email),
        emailStatus: getBool(v.emailStatus) ?? false,
        dateOfBirth,
        address,
        // addresses: v.addresses,
        marketing,
    };
};
